module.exports = __webpack_public_path__ + "img/404_01.cb4ae172.jpg";